module.exports = __webpack_public_path__ + "static/img/select-job.17f827d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/browser-extension/select-job.jpg
// module id = RGSN
// module chunks = 1